// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".membership-airline-select[data-v-4f3355c8]  .vs__dropdown-toggle{height:38px!important;border:0!important;padding-bottom:3px!important}.membership-airline-select[data-v-4f3355c8]  .vs__dropdown-toggle .vs__open-indicator{margin-top:0!important}.membership-airline-select[data-v-4f3355c8]  ul.vs__dropdown-menu{min-width:300px!important}", ""]);
// Exports
module.exports = exports;
